import logger from 'logger';
import { getAuthClient } from './clients';

export async function getUnauthedToken(input: {
  domain: string;
  cookieHeader?: string;
}): Promise<{
  tenantId: number;
  anonymousId: string;
  // The cookie values are provided for server-to-server calls. Client-side these are
  // passed automatically.
  setCookies?: string[];
}> {
  const { domain, cookieHeader } = input;
  const client = getAuthClient();

  let res;
  try {
    res = await client.post<{
      success: boolean;
      data: { tenantId: number; anonymousId: string };
      error: {
        code: number | null;
        message: string | null;
        validation: unknown;
      };
    }>(
      '/unauth-token',
      { domain },
      {
        headers: cookieHeader ? { Cookie: cookieHeader } : undefined,
      },
    );
  } catch (err: any) {
    logger.error({
      msg: 'UnauthTokenRequestFailed',
      noticable: err,
      extra: {
        context: { domain, status: err?.response?.status },
      },
    });
    throw err;
  }

  if (!res.data?.success || !res.data?.data) {
    const err = new Error('unauth-token response did not include tenant data');
    logger.error({
      msg: 'UnauthTokenNonOkResponse',
      noticable: err,
      extra: { context: { domain } },
    });
    throw err;
  }

  const rawSetCookie = res.headers['set-cookie'];
  const setCookies = Array.isArray(rawSetCookie)
    ? rawSetCookie
    : rawSetCookie
      ? [rawSetCookie]
      : undefined;

  return {
    tenantId: res.data.data.tenantId,
    anonymousId: res.data.data.anonymousId,
    setCookies,
  };
}
